import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { inlineDownloadUtils } from '../../hotel-center-utils';
import template from './template.pug';
import { PerformanceReportBase } from '../helper/performance-report-factory';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export default class BookingReportView extends PerformanceReportBase {
  constructor({ p$daterange = null, perfMarker = null } = {}) {
    const reportColumns = [
      'SubAccountName',
      'HotelGroupName',
      'HotelId',
      'PartnerHotelId',
      'HotelName',
      'BookingReferenceNumber',
      'BookingDate',
      'CheckinDate',
      'TotalBookedNights',
      'TotalPrice',
      'BasePrice',
      'Taxes',
    ];
    const reportHeaders = [
      i18n.getString('HotelCenter_Overview_Grid_Booking_Subaccount_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Hotel_Group_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Hotel_ID_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Partner_Hotel_ID_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Hotel_Name_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Reference_Number_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Date_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Checkin_Date_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Length_Of_Stay_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Total_Price_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Base_Price_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Booking_Taxes_Fees_Label'),
    ];

    const bookingPerfMarker = perfMarker ? perfMarker.createChild('HotelCenterBookingReport') : null;

    super({
      getTemplate: () => template,
      downloadButtonLocator: '.booking-report-download-button',
      reportColumns,
      reportHeaders,
      gridId: 'HotelBookingReportDownloadGrid',
      processReportRule: inlineDownloadUtils.processReportRuleForHotelCenterBookingRow,
      p$daterange,
      perfMarker: bookingPerfMarker,
    });
  }
}
